import * as React from 'react';

import Dropdown from 'af-components/Controls/Dropdown';

import styles from './styles.module.scss';

interface AdditionalFilterOption {
	id: string;
	label: string;
}

interface Props {
	options: AdditionalFilterOption[];
	// onChange: (id: number) => void;
	// defaultValue?: number;
	disabled?: boolean;
	addAdditionalFilter: (option: AdditionalFilterOption) => void;
}

const AddFilter: React.FC<Props> = ({ options, addAdditionalFilter, disabled }) => {

	const renderAdditionalFilterOption = React.useCallback((option: AdditionalFilterOption) => {
		return (
			<div className={styles.option}>
				{option.label}
			</div>
		);
	}, []);

	const renderPlaceholder = React.useMemo(() => {
		return (
			<div className={styles.placeholder}>
				Add filter
				<span className={`icon-plus ${styles.icon}`} />
			</div>
		);
	}, []);

	if (!options.length) {
		return <></>;
	}

	return (
		<Dropdown<AdditionalFilterOption>
			containerClassName={styles.container}
			defaultValue={null}
			disabled={disabled}
			dropdownId="accqa__add-additional-filter"
			forcePlaceholder={true}
			onValueChange={addAdditionalFilter}
			options={options}
			placeholder={renderPlaceholder}
			renderMenuItem={renderAdditionalFilterOption}
			valueKey="id"
			withBorder={false}
		/>
	);
};

export default React.memo(AddFilter);
